import React from 'react'
import { useTranslation } from 'react-i18next'
import { ColorPickerStandaloneControl } from 'src/editor/shared/settings/controls/color-picker/color-picker-standalone-control'
import { ImageControlStandalone } from 'src/editor/shared/settings/controls/image-control/image-control-standalone'
import { Dropdown } from 'src/editor/shared/ui-lib/dropdown'
import { dropdownTitlesLocoKeys } from './consts'
import { WebsiteDropdownTitles, WebsiteThemeGroupType } from './types'

interface WebsiteThemeDropdownProps<T> {
  data: T
  title: string
  onUpdate: (key: string, value: string | number | null) => void
}

export const WebsiteThemeDropdown = <T extends WebsiteThemeGroupType>({
  data,
  title,
  onUpdate,
}: WebsiteThemeDropdownProps<T>) => {
  const { t } = useTranslation()
  return (
    data && (
      <Dropdown title={title} classNameDropdown="flex flex-col gap-4">
        {Object.entries(data).map(el => (
          <div key={el[0]} className="flex items-center justify-between">
            <h5 className="text-M text-textPrimary">
              {t(dropdownTitlesLocoKeys[el[0] as WebsiteDropdownTitles])}
            </h5>
            <div>
              {typeof el[1] === 'string' ? (
                <ColorPickerStandaloneControl
                  color={el[1]}
                  update={color => onUpdate(el[0], color)}
                />
              ) : (
                <ImageControlStandalone
                  fileId={el[1]}
                  updateBackgroundFileId={fileId =>
                    onUpdate(el[0], fileId ?? null)
                  }
                />
              )}
            </div>
          </div>
        ))}
      </Dropdown>
    )
  )
}
